const CodecGenericName: Record<string, string> = {
    avc1: 'AVC',
    'ec-3': 'EC-3', // The Dolby codec
    hev1: 'HEVC',
    hvc1: 'HEVC',
    mp4a: 'AAC',
};

export {CodecGenericName};
